import React from 'react';
import enhance from './enhance';
import PropTypes from 'prop-types';
import styles from './styles.module.scss';

export const WebShopClose = ({
  closed,
  formattedTimeToClose,
  isWebShopClosed,
  timePrefix,
  timeSuffix,
  webshopClosedContainerStyle,
  webshopOpenContainerStyle,
}) => (
  <div
    className={
      isWebShopClosed ? webshopClosedContainerStyle : webshopOpenContainerStyle
    }
  >
    {isWebShopClosed ? (
      <span>{closed}</span>
    ) : (
      <span className={styles.timeContainer}>
        {timePrefix} <span className={styles.time}>{formattedTimeToClose}</span>{' '}
        {timeSuffix}
      </span>
    )}
  </div>
);

WebShopClose.propTypes = {
  closed: PropTypes.string.isRequired,
  formattedTimeToClose: PropTypes.string,
  isWebShopClosed: PropTypes.bool.isRequired,
  timePrefix: PropTypes.string.isRequired,
  timeSuffix: PropTypes.string.isRequired,
};

export default enhance(WebShopClose);
